<template>
  <div class="login-page">
    <div class="login-bg"></div>
    <div class="login-card">
      <div class="brand-row">
        <div class="logo">七</div>
        <div>
          <h1>小七运行监控台</h1>
          <p>后端状态 · 任务 · 留痕</p>
        </div>
      </div>

      <el-form :model="form" :rules="rules" ref="loginForm" @submit.native.prevent>
        <el-form-item prop="username">
          <el-input
            v-model="form.username"
            prefix-icon="el-icon-user"
            placeholder="请输入账号"
            autocomplete="username"
            @keyup.enter.native="handleLogin"
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="form.password"
            type="password"
            show-password
            prefix-icon="el-icon-lock"
            placeholder="请输入密码"
            autocomplete="current-password"
            @keyup.enter.native="handleLogin"
          />
        </el-form-item>
        <el-button type="primary" class="login-button" :loading="loading" @click="handleLogin">登录监控台</el-button>
      </el-form>

      <div class="hint">
        账号密码由后端认证接口校验，前端不内置固定密码。
      </div>
    </div>
  </div>
</template>

<script>
import { authApi } from '@/api/auth'
import { setAuthData } from '@/utils/auth'

export default {
  name: 'Login',
  data() {
    return {
      loading: false,
      form: {
        username: 'admin',
        password: ''
      },
      rules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    async handleLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (!valid) return
        this.loading = true
        try {
          const res = await authApi.login({
            username: this.form.username,
            password: this.form.password
          })
          if (res && res.success === false) throw new Error(res.message || res.detail || '登录失败')
          setAuthData({
            ...(res || {}),
            user: (res && (res.user || res.profile)) || { name: this.form.username || '管理员' }
          })
          this.$message.success('登录成功')
          this.$router.replace(this.$route.query.redirect || '/dashboard')
        } catch (error) {
          this.$message.error(error.message || '登录失败，请检查账号、密码或后端认证接口')
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.login-page {
  position: fixed;
  inset: 0;
  z-index: 5000;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
  background: #e7edf6;
  overflow: hidden;
}

.login-bg {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 30% 18%, rgba(37, 99, 235, 0.28), transparent 28%),
    radial-gradient(circle at 72% 76%, rgba(96, 165, 250, 0.26), transparent 30%),
    linear-gradient(135deg, #edf4ff 0%, #d7e6f8 52%, #eaf0f8 100%);
}

.login-card {
  position: relative;
  width: 420px;
  padding: 34px;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius: 22px;
  box-shadow: 0 28px 80px rgba(15, 23, 42, 0.18);
  backdrop-filter: blur(18px);
}

.brand-row {
  display: flex;
  align-items: center;
  margin-bottom: 26px;
}

.logo {
  width: 56px;
  height: 56px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
  color: #fff;
  font-size: 24px;
  font-weight: 800;
  background: linear-gradient(135deg, #1d4ed8 0%, #60a5fa 100%);
  box-shadow: 0 16px 36px rgba(37, 99, 235, 0.26);
}

h1 {
  margin: 0;
  font-size: 23px;
  color: #0f172a;
}

p {
  margin: 5px 0 0;
  color: #64748b;
  font-size: 13px;
}

.login-button {
  width: 100%;
  border-radius: 12px;
  height: 42px;
}

.hint {
  margin-top: 16px;
  color: #7f8ea3;
  font-size: 12px;
  text-align: center;
}
</style>
